import React from 'react'
import AniLink from "gatsby-plugin-transition-link/AniLink"

const Logo = ({ logo, className }) => (
    <AniLink cover bg="#FA7C91" to="/" href="/" className={`navbar-item logo ${className}`} duration={0.6} direction="up">
        {logo}
    </AniLink>
)

export default Logo